import { StyleSheet } from 'aphrodite'

import list from './list'
import item from './item'

export default {
  list: StyleSheet.create(list),
  item: StyleSheet.create(item)
}



// WEBPACK FOOTER //
// ./src/components/Statistics/partials/RevenueTable/style/ColorBlind/index.js